import { Flex } from '@chakra-ui/react';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { ReplaceButton, useWidget } from 'widgets/sdk';

export const LottieWidgetToolbar = () => {
  const { widgetId } = useWidget();

  return (
    <Flex align='center' gap='2'>
      <ReplaceButton isElement />

      <ToolbarDivider />
      <AltTextMenu widgetId={widgetId} />
    </Flex>
  );
};

LottieWidgetToolbar.displayName = 'LottieWidgetToolbar';
